module.exports = __webpack_public_path__ + "img/5ae4fb51-10aa-42c7-91d6-01cc0a716db1.1afa55c7.jpg";